<template>
  <!-- 修改密码弹窗 -->
  <mrc_ess_myDialog
    v-model="dialog"
    :title="$t('label_ChangePassword')"
    width="680"
    :loading="loading"
    @success="savePassword"
    @cancel="
      () => {
        dialog = false;
      }
    "
  >
    <v-row>
      <v-col cols="12">
        <mrc_ess_input
          :placeholder="$t('label_account')"
          :label="$t('label_account')"
          v-model="params.account"
          readonly
          disabled
        ></mrc_ess_input>
      </v-col>

      <v-col cols="12">
        <mrc_ess_input
          :label="$t('label_newpassword') + '*'"
          :placeholder="$t('label_newpassword') + '*'"
          background-color="#fff"
          @input="$v.params.user_pwd.$touch()"
          @blur="$v.params.user_pwd.$touch()"
          v-model.trim="params.user_pwd"
          :type="type"
          :append-icon="icon"
          @click:append="showPassword"
          :error-messages="
            $errors(
              'params',
              'user_pwd',
              requiredRule.concat(
                { rule: 'isChina', msg: $t('verify_not_input_chinese') },
                { rule: 'passwordStrengthRegxRule', msg: regxMsg }
              )
            )
          "
        ></mrc_ess_input>
      </v-col>
      <v-col cols="12">
        <mrc_ess_input
          :placeholder="$t('label_Retypepassword') + '*'"
          :label="$t('label_Retypepassword') + '*'"
          background-color="#fff"
          @input="$v.params.RetypePwd.$touch()"
          @blur="$v.params.RetypePwd.$touch()"
          :append-icon="icon"
          :type="type"
          @click:append="showPassword"
          v-model.trim="params.RetypePwd"
          :error-messages="
            $errors(
              'params',
              'RetypePwd',
              requiredRule.concat([
                { rule: 'sameAsNewPassword', msg: $t('error_not_same_password') },
              ])
            )
          "
        ></mrc_ess_input>
      </v-col>
    </v-row>
  </mrc_ess_myDialog>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import { updatePassword, passwordStrength } from "@/service/api/forgot-password";
export default {
  data() {
    return {
      dialog: false,
      icon: "mdi-eye-off",
      type: "password",
      is_showPassword: false,
      regxRule: null,
      loading: false,
      regxMsg: "",
      params: {
        account: "", // 旧密码
        user_id: "", // 旧密码
        user_pwd: "", // 新密码
        RetypePwd: "", // 再次输入新密码
      },
    };
  },
  validations: {
    params: {
      user_pwd: {
        required,
        isChina(val) {
          return this.isChina(val);
        },
        passwordStrengthRegxRule(val) {
          return new RegExp(this.regxRule).test(val);
        },
      },
      RetypePwd: {
        required,
        sameAsNewPassword(val) {
          return val && val == this.params.user_pwd;
        },
      },
    },
  },
  methods: {
    async active(data) {
      this.$v.params.$reset();
      this.params.account = data.user_account || "";
      this.params.user_id = data.user_id || "";
      this.dialog = true;
      await this.getPasswordStrength(this.params.account);
    },
    async getPasswordStrength(account) {
      await this.$store.dispatch("setPubk");
      const res = await passwordStrength({
        user_account: this.$encrypt({
          msg: account,
          key: this.$store.getters.pubk,
        }),
      });
      if (res.code == 200) {
        this.regxMsg = res.data.ceckmean;
        this.regxRule = res.data.cecknum;
      }
    },
    showPassword() {
      this.is_showPassword = !this.is_showPassword;
      if (this.is_showPassword) {
        this.icon = "mdi-eye";
        this.type = "text";
      } else {
        this.icon = "mdi-eye-off";
        this.type = "password";
      }
    },
    async savePassword() {
      this.$v.params.$touch();
      if (this.$v.params.$error) return;
      this.loading = true;
      const res = await updatePassword({
        staff_uuid: this.params.user_id,
        user_pwd: this.params.user_pwd,
        // user_pwd: this.$encrypt({
        //   msg: this.params.user_pwd,
        //   key: this.$store.getters.pubk,
        // }),
      });
      if (res.code == 200) {
        this.$Message({
          text: this.$t("message_The_modification_was_successful"),
        });
        this.dialog = false;
      }
      this.loading = false;
    },
  },
};
</script>
